"use client"

import { useId } from "react"
import { useManagedDialog } from "./use-managed-dialog.ts"

export const AccountDeletionConditionsModal = ({ onClose, open }: { readonly onClose: () => void; readonly open: boolean }) => {
  const headingId = useId()
  const { cancel, dialogRef, onDialogClose } = useManagedDialog(open, onClose)

  return (
    <dialog
      aria-labelledby={headingId}
      className="checkout-terms-dialog"
      data-account-deletion-conditions
      onCancel={(event) => {
        event.preventDefault()
        cancel()
      }}
      onClose={onDialogClose}
      ref={dialogRef}
    >
      <div className="checkout-terms-content">
        <header className="checkout-terms-heading">
          <div>
            <span className="eyebrow">계정 관리</span>
            <h2 id={headingId}>계정 삭제 조건</h2>
          </div>
          <button aria-label="계정 삭제 조건 닫기" className="checkout-terms-icon-close" onClick={cancel} type="button">
            ×
          </button>
        </header>
        <ul className="checkout-terms-list">
          <li>남은 잔액과 보류 금액이 0원이고 진행 중인 거래가 없어야 삭제할 수 있습니다.</li>
          <li>삭제가 완료되면 로그인 정보, 프로필, 휴대전화 인증 정보와 푸시 토큰을 제거하고 현재 세션을 종료합니다.</li>
          <li>거래 원장과 감사 기록 등 법령상 보관이 필요한 정보는 정해진 기간 동안 다른 정보와 분리해 보관합니다.</li>
          <li>계정 삭제가 완료된 뒤에는 같은 계정을 복구할 수 없습니다.</li>
        </ul>
        <button className="button primary checkout-terms-close" onClick={cancel} type="button">
          확인
        </button>
      </div>
    </dialog>
  )
}
